var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4029",
    d: "M29.7917 1.81859H11.2092C9.57268 1.81859 8.24597 3.1453 8.24597 4.7818V13.4839H32.7549V4.7818C32.7549 3.1453 31.4283 1.81859 29.7917 1.81859Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4033",
    d: "M30.9211 10.6992H10.0792C7.91308 10.6992 6.1571 12.4552 6.1571 14.6213V35.5298H34.8432V14.6213C34.8432 12.4552 33.0872 10.6992 30.9211 10.6992Z",
    fill: "#FF919E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4037",
    d: "M22.3328 24.4991H18.6671C17.6553 24.4991 16.8351 25.3193 16.8351 26.3311V35.5298H24.1649V26.3311C24.1649 25.3193 23.3446 24.4991 22.3328 24.4991Z",
    fill: "#6A647F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4041",
    d: "M12.2937 24.4991H10.698C9.96305 24.4991 9.36719 25.0949 9.36719 25.8299V29.0311C9.36719 29.766 9.96305 30.3618 10.698 30.3618H12.2937C13.0286 30.3618 13.6244 29.766 13.6244 29.0311V25.8299C13.6244 25.0949 13.0286 24.4991 12.2937 24.4991Z",
    fill: "#FFEA98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4045",
    d: "M12.2937 14.9415H10.698C9.96305 14.9415 9.36719 15.5373 9.36719 16.2723V19.4734C9.36719 20.2084 9.96305 20.8042 10.698 20.8042H12.2937C13.0286 20.8042 13.6244 20.2084 13.6244 19.4734V16.2723C13.6244 15.5373 13.0286 14.9415 12.2937 14.9415Z",
    fill: "#FFEA98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4049",
    d: "M21.2984 14.9415H19.7027C18.9677 14.9415 18.3719 15.5373 18.3719 16.2723V19.4734C18.3719 20.2084 18.9677 20.8042 19.7027 20.8042H21.2984C22.0333 20.8042 22.6292 20.2084 22.6292 19.4734V16.2723C22.6292 15.5373 22.0333 14.9415 21.2984 14.9415Z",
    fill: "#FFEA98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4053",
    d: "M28.7059 24.4991H30.3015C31.0365 24.4991 31.6323 25.0949 31.6323 25.8299V29.0311C31.6323 29.766 31.0365 30.3618 30.3015 30.3618H28.7059C27.9709 30.3618 27.3751 29.766 27.3751 29.0311V25.8299C27.3751 25.0949 27.9709 24.4991 28.7059 24.4991Z",
    fill: "#FFEA98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4057",
    d: "M28.7059 14.9415H30.3015C31.0365 14.9415 31.6323 15.5373 31.6323 16.2723V19.4734C31.6323 20.2084 31.0365 20.8042 30.3015 20.8042H28.7059C27.9709 20.8042 27.3751 20.2084 27.3751 19.4734V16.2723C27.3751 15.5373 27.9709 14.9415 28.7059 14.9415Z",
    fill: "#FFEA98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4061",
    d: "M34.5848 33.32H6.41648C5.18064 33.32 4.17871 34.3219 4.17871 35.5577V36.938C4.17871 37.6249 4.73558 38.1816 5.42238 38.1816H35.5789C36.2658 38.1816 36.8225 37.6249 36.8225 36.938V35.5577C36.8225 34.3219 35.8206 33.32 34.5848 33.32Z",
    fill: "#D7D6D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4065",
    d: "M7.72855 22.1671C7.72855 18.0157 8.77811 14.1097 10.6261 10.6993H10.0792C7.91308 10.6993 6.1571 12.4553 6.1571 14.6213V35.5298H11.7696C9.2174 31.7051 7.72855 27.1102 7.72855 22.1671Z",
    fill: "#FF737D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4069",
    d: "M10.4603 33.32H6.41641C5.18057 33.32 4.17871 34.3219 4.17871 35.5577V36.938C4.17871 37.6249 4.73543 38.1816 5.42231 38.1816H13.8191C12.5109 36.7111 11.3802 35.0795 10.4603 33.32Z",
    fill: "#C5C4C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4073",
    d: "M10.7894 17.1087C10.7894 16.3892 10.7528 15.6271 10.8799 14.9414H10.6979C9.96297 14.9414 9.36719 15.5372 9.36719 16.2723V19.4734C9.36719 20.2083 9.96297 20.8042 10.6979 20.8042H12.2937C12.5954 20.8042 12.8728 20.7026 13.096 20.5333C11.7435 19.9842 10.7894 18.6583 10.7894 17.1087Z",
    fill: "#F9D888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4077",
    d: "M19.7941 17.1087C19.7941 16.3892 19.7576 15.6271 19.8846 14.9414H19.7027C18.9677 14.9414 18.3719 15.5372 18.3719 16.2723V19.4734C18.3719 20.2083 18.9677 20.8042 19.7027 20.8042H21.2984C21.6002 20.8042 21.8775 20.7026 22.1007 20.5333C20.7483 19.9842 19.7941 18.6583 19.7941 17.1087Z",
    fill: "#F9D888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4081",
    d: "M28.7973 17.1087C28.7973 16.3892 28.7607 15.6271 28.8878 14.9414H28.7059C27.9709 14.9414 27.3751 15.5372 27.3751 16.2723V19.4734C27.3751 20.2083 27.9709 20.8042 28.7059 20.8042H30.3015C30.6033 20.8042 30.8806 20.7026 31.1039 20.5333C29.7515 19.9842 28.7973 18.6583 28.7973 17.1087Z",
    fill: "#F9D888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4085",
    d: "M10.7894 26.6663C10.7894 25.9469 10.7528 25.1847 10.8799 24.4991H10.6979C9.96297 24.4991 9.36719 25.0948 9.36719 25.8299V29.031C9.36719 29.766 9.96297 30.3618 10.6979 30.3618H12.2937C12.5954 30.3618 12.8728 30.2602 13.096 30.0909C11.7435 29.5419 10.7894 28.2159 10.7894 26.6663Z",
    fill: "#F9D888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4089",
    d: "M28.7973 26.6663C28.7973 25.9469 28.7607 25.1847 28.8878 24.4991H28.7059C27.9709 24.4991 27.3751 25.0948 27.3751 25.8299V29.031C27.3751 29.766 27.9709 30.3618 28.7059 30.3618H30.3015C30.6033 30.3618 30.8806 30.2602 31.1039 30.0909C29.7515 29.5419 28.7973 28.2159 28.7973 26.6663Z",
    fill: "#F9D888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4093",
    d: "M12.2937 24.4991H10.698C9.96305 24.4991 9.36719 25.0949 9.36719 25.8299V29.031C9.36719 29.766 9.96305 30.3618 10.698 30.3618H12.2937C13.0286 30.3618 13.6244 29.766 13.6244 29.031V25.8299C13.6244 25.0949 13.0286 24.4991 12.2937 24.4991Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4097",
    d: "M12.2937 14.9415H10.698C9.96305 14.9415 9.36719 15.5374 9.36719 16.2723V19.4735C9.36719 20.2084 9.96305 20.8042 10.698 20.8042H12.2937C13.0286 20.8042 13.6244 20.2084 13.6244 19.4735V16.2723C13.6244 15.5374 13.0286 14.9415 12.2937 14.9415Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4101",
    d: "M21.2984 14.9415H19.7027C18.9677 14.9415 18.3719 15.5374 18.3719 16.2723V19.4735C18.3719 20.2084 18.9677 20.8042 19.7027 20.8042H21.2984C22.0333 20.8042 22.6291 20.2084 22.6291 19.4735V16.2723C22.6291 15.5374 22.0333 14.9415 21.2984 14.9415Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4105",
    d: "M28.7059 24.4991H30.3015C31.0365 24.4991 31.6323 25.0949 31.6323 25.8299V29.031C31.6323 29.766 31.0365 30.3618 30.3015 30.3618H28.7059C27.9709 30.3618 27.3751 29.766 27.3751 29.031V25.8299C27.3751 25.0949 27.9709 24.4991 28.7059 24.4991Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4109",
    d: "M28.7059 14.9415H30.3015C31.0365 14.9415 31.6323 15.5374 31.6323 16.2723V19.4735C31.6323 20.2084 31.0365 20.8042 30.3015 20.8042H28.7059C27.9709 20.8042 27.3751 20.2084 27.3751 19.4735V16.2723C27.3751 15.5374 27.9709 14.9415 28.7059 14.9415Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4149",
    d: "M10.0795 10.6994H30.9214C31.5839 10.6994 32.2076 10.8643 32.7549 11.1543V4.78165C32.7549 3.14509 31.4283 1.81845 29.7916 1.81845H11.2092C9.57268 1.81845 8.24597 3.14509 8.24597 4.78165V11.1543C8.79325 10.8643 9.41699 10.6994 10.0795 10.6994Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4153",
    d: "M6.1571 27.9997V33.3354C6.24212 33.3256 6.32839 33.3201 6.41604 33.3201H34.5843C34.6719 33.3201 34.7582 33.3256 34.8432 33.3354V20.1807",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4157",
    d: "M34.8432 21.3909V14.6212C34.8432 12.4551 33.0872 10.6991 30.9211 10.6991H10.0792C7.91308 10.6991 6.1571 12.4551 6.1571 14.6212V29.21",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4161",
    d: "M24.1649 33.3198V26.331C24.1649 25.3191 23.3446 24.4989 22.3328 24.4989H18.6671C17.6553 24.4989 16.8351 25.3191 16.8351 26.331V33.3198H24.1649Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4165",
    d: "M34.5848 33.32H6.41648C5.18064 33.32 4.17871 34.3219 4.17871 35.5577V36.938C4.17871 37.6249 4.7355 38.1816 5.42238 38.1816H35.5789C36.2658 38.1816 36.8225 37.6249 36.8225 36.938V35.5577C36.8225 34.3219 35.8206 33.32 34.5848 33.32Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.e7bbf42bd3ba048089cbcbcbef7c8be9.svg";
export { ForwardRef as ReactComponent };